import { LazyModule, LazyImport } from 'owa-bundling';
import type Mark from 'mark.js';

type MarkModule = {
    default: typeof Mark;
    prototype: Mark;
};

// eslint-disable-next-line owa-custom-rules/require-lazy-import-passthrough-types -- Special case due to the CJS module
const lazyModule: LazyModule<MarkModule> = new LazyModule<MarkModule>(
    () => import(/* webpackChunkName: "MarkJS" */ 'mark.js'),
    {
        name: 'MarkJS',
    }
);

const lazyMarkJs: LazyImport<typeof Mark, typeof lazyModule> = new LazyImport(
    lazyModule,
    m => m.default
);

let MarkJS: typeof Mark | null = null;
export async function getMarkJS(): Promise<typeof Mark> {
    if (!MarkJS) {
        const result = await lazyMarkJs.import();
        MarkJS = result;
    }
    return MarkJS;
}

export const SPAN_ELEMENT_NAME = 'span';
export const UNMARK_ELEMENT_LABEL = 'unmark';

export const MARK_ID_PREFIX = 'mark';
export const MARK_ID_NUMBER_LEN = 9;
